import { render, staticRenderFns } from "./AssetAdd.vue?vue&type=template&id=c0894e72&"
import script from "./AssetAdd.vue?vue&type=script&lang=js&"
export * from "./AssetAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports